import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=09ce24b0&scoped=true&"
import script from "./AdminContainer.vue?vue&type=script&lang=ts&"
export * from "./AdminContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminContainer.vue?vue&type=style&index=0&id=09ce24b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce24b0",
  null
  
)

export default component.exports